import { CajaCurricularPciI } from "interfaces/CajaCurricularPci";
import { EspacioCurricularPciI } from "interfaces/EspacioCurricularPci";
import {
  infoFetchGetEspacioCurricularPciI,
  makeEspacioCurricularPci,
} from "./espacioCurricularPci";
import { CajaCurricularI } from "interfaces/CajaCurricular";

export interface infoFetchGetCajaCurricularPciI {
  id: number | string;
  caja_curricular_id: number;
  descripcion: string;
  version: string;
  cajaCurricularBase: CajaCurricularI;
  espaciosCurricularesPci: infoFetchGetEspacioCurricularPciI[];
}

class CajaCurricularPci implements CajaCurricularPciI {
  id: number | string;
  caja_curricular_id: number;
  descripcion: string;
  version: string;
  cajaCurricularBase: CajaCurricularI;
  espaciosCurricularesPci: EspacioCurricularPciI[];

  constructor(infoFetch: infoFetchGetCajaCurricularPciI) {
    this.id = infoFetch.id;
    this.descripcion = infoFetch.descripcion;
    this.version = infoFetch.version;
    this.espaciosCurricularesPci = infoFetch.espaciosCurricularesPci
      ? infoFetch.espaciosCurricularesPci
          .filter((ct) => ct != null)
          .map((ct) => makeEspacioCurricularPci(ct))
      : [];
    this.caja_curricular_id = infoFetch.caja_curricular_id;
    this.cajaCurricularBase = infoFetch.cajaCurricularBase;
  }
}

export const makeCajaCurricularPci = (
  infoFetch: infoFetchGetCajaCurricularPciI,
) => {
  return new CajaCurricularPci(infoFetch);
};
